import fsCustomEvent from '@/utils/fsCustomEvent'
const sendFsCustomEvent = {
  methods: {
    sendFsEvent (eventName, eventProperties) {
      fsCustomEvent(eventName, eventProperties)
    }
  }
}

export default sendFsCustomEvent
